import { ChainId } from '@zinuswap/sdk'
import { chainId } from 'wagmi'

export const SUPPORT_ONLY_BSC = [ChainId.MAINNETZ,ChainId.BASE,ChainId.MAINNETZ_TESTNET]
export const SUPPORT_FARMS = [ChainId.MAINNETZ,ChainId.BASE, ChainId.BSC, ChainId.BSC_TESTNET, ChainId.ETHEREUM, ChainId.GOERLI]

export const SUPPORT_ZAP = [] // TODO-SD
